(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["loren-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-loren-announcement]').forEach((el) => {
    const msgs = el.querySelectorAll('.loren-ann__msg');
    if (msgs.length <= 1) return;
    let i = 0;
    const speed = (parseInt(el.dataset.speed, 10) || 5) * 1000;
    const autoplay = el.dataset.autoplay === 'true';
    let timer;

    const show = (n) => {
      msgs.forEach((m, idx) => m.classList.toggle('is-active', idx === n));
      i = n;
    };
    const next = () => show((i + 1) % msgs.length);
    const prev = () => show((i - 1 + msgs.length) % msgs.length);

    el.querySelector('[data-next]')?.addEventListener('click', () => { next(); restart(); });
    el.querySelector('[data-prev]')?.addEventListener('click', () => { prev(); restart(); });

    const start = () => { if (autoplay) timer = setInterval(next, speed); };
    const restart = () => { clearInterval(timer); start(); };
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
